import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TabCommunicationService {
  private worker: SharedWorker;
  private port: MessagePort;
  private messageSubject = new Subject<any>();

  message$ = this.messageSubject.asObservable();

  constructor(private router : Router) {
    if ('SharedWorker' in window) {
      this.worker = new SharedWorker('/assets/shared-worker.js');
      this.port = this.worker.port;

      this.port.onmessage = (event) => {
        const { type, message } = event.data;
        if (type === 'connected') {
          console.log(message);
        } else if (type === 'broadcast') {
          console.log('📨 Message received from another tab:', message);
          this.messageSubject.next(message);
          this.router.navigateByUrl('auth/login')
        }
      };

      this.port.start();
    } else {
      console.error('SharedWorker is not supported in this browser.');
    }
  }

  sendMessage(data: any) {
    if (this.port) {
      this.port.postMessage(data);
    }
  }
}
